// /components/Contact/index.js
import Contact from "./Contact";

export default Contact;
